import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import MaskedInput from 'react-maskedinput';
import { FormControl } from 'react-bootstrap';

function MaskedFormControl(props) {
  return /*#__PURE__*/React.createElement(FormControl, _extends({
    as: MaskedInput
  }, props));
}

MaskedFormControl.displayName = "MaskedFormControl";
var BaseMaskedFormControl = MaskedFormControl;
export { BaseMaskedFormControl };